export function mapGruposToTalleresOptions(grupoSet: any[] = []) {
  return grupoSet.map((g) => ({
    label:
      g.cupoDisponible > 0
        ? `${g.nombre} (${g.cupoDisponible} cupos)`
        : `${g.nombre} (sin cupos)`,
    value: Number(g.id),
    disabled: g.cupoDisponible <= 0,
    cupoDisponible: g.cupoDisponible,
  }));
}

function parseUniversidad(universidad?: string | null) {
  if (!universidad) {
    return { pertenecienteA: undefined, pertenecienteAOtro: undefined };
  }
  if (universidad.startsWith("Otro:")) {
    return {
      pertenecienteA: "Otro",
      pertenecienteAOtro: universidad.replace(/^Otro:\s*/, ""),
    };
  }
  return { pertenecienteA: universidad, pertenecienteAOtro: undefined };
}

export function mapEiduFormValues(values: any, periodoMatriculaId: number) {
  const pertenecienteA =
    values.pertenecienteA === "Otro"
      ? `Otro: ${values.pertenecienteAOtro}`
      : values.pertenecienteA;

  const tallerId =
    values.taller != null && values.taller !== ""
      ? Number(values.taller)
      : null;

  return {
    tipo: 1,
    identificacion: String(values.identificacion ?? "").replace(/\D/g, ""),
    nombre: values.nombre,
    correoInstitucional: values.correoContacto,
    telefono: values.telefono,
    unidad: values.unidad,
    carrera: values.carrera,
    periodoMatricula: periodoMatriculaId,
    grupo: tallerId,
    universidad: pertenecienteA,
    pais: values.pais,
    tieneDiscapacidad: values.tieneDiscapacidad === "si",
    tipoDiscapacidad:
      values.tieneDiscapacidad === "si" && values.tipoDiscapacidad?.length
        ? values.tipoDiscapacidad.join(", ")
        : null,
    requiereApoyo: values.requiereApoyo === "si",
    detalleApoyo: values.requiereApoyo === "si" ? values.detalleApoyo : null,
  };
}

export function docenteToEiduInitialValues(
  docente: any,
  options?: { taller?: number; talleres?: number[] }
) {
  const { pertenecienteA, pertenecienteAOtro } = parseUniversidad(
    docente.universidad
  );

  return {
    correoContacto: docente.correoInstitucional,
    confirmacionCorreo: docente.correoInstitucional,
    nombre: docente.nombre,
    identificacion: docente.identificacion,
    pais: docente.pais ?? "",
    telefono: docente.telefono ?? "",
    pertenecienteA,
    pertenecienteAOtro,
    unidad: docente.unidad ?? "",
    carrera: docente.carrera ?? "",
    taller: options?.taller ?? options?.talleres?.[0],
    tieneDiscapacidad: docente.tieneDiscapacidad ? "si" : "no",
    tipoDiscapacidad:
      docente.tipoDiscapacidad?.split(", ").filter(Boolean) ?? [],
    requiereApoyo: docente.requiereApoyo ? "si" : "no",
    detalleApoyo: docente.detalleApoyo ?? "",
  };
}

export function mapEiduFormToEditValues(values: any, docenteId: number) {
  const base = mapEiduFormValues(values, 0);
  return {
    id: docenteId,
    tipo: base.tipo,
    identificacion: base.identificacion,
    nombre: base.nombre,
    correoInstitucional: base.correoInstitucional,
    telefono: base.telefono,
    unidad: base.unidad,
    carrera: base.carrera,
    universidad: base.universidad,
    pais: base.pais,
    tieneDiscapacidad: base.tieneDiscapacidad,
    tipoDiscapacidad: base.tipoDiscapacidad,
    requiereApoyo: base.requiereApoyo,
    detalleApoyo: base.detalleApoyo,
  };
}
